module.exports = __webpack_public_path__ + "img/download-gray.4666fbdb.svg";